(function () {
 'use strict';
 function initialize(root) {
  root.querySelectorAll('[data-country-search]').forEach(function (input) {
   if (input.dataset.initialized) return;
   input.dataset.initialized = 'true';
   const picker = input.closest('.value-picker');
   const choices = Array.from(picker.querySelectorAll('button[name="country_code"]'));
   const separator = picker.querySelector('.value-picker__separator');
   const empty = picker.querySelector('[data-country-empty]');
   function normalize(value) { return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim(); }
   function filter() {
    const query = normalize(input.value);
    let count = 0;
    choices.forEach(function (button) {
     const matches = normalize(button.textContent + ' ' + button.value).includes(query);
     button.closest('li').hidden = !matches;
     if (matches) count++;
    });
    if (separator) separator.hidden = !!query;
    if (empty) empty.hidden = count !== 0;
   }
   input.addEventListener('input', filter);
   input.addEventListener('search', filter);
   input.addEventListener('keydown', function (event) { if (event.key === 'Enter') event.preventDefault(); });
  });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
 else initialize(document);
 document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();

